import React, { createContext, useReducer, useContext } from 'react';

// Define the actions
const ADD_LAYER = 'ADD_LAYER';
const DELETE_LAYER = 'DELETE_LAYER';
const CHANGE_LAYER = 'CHANGE_LAYER';
const SET_LAYERS = 'SET_LAYERS';

const MOVE_LAYER_UP = 'MOVE_LAYER_UP';
const MOVE_LAYER_DOWN = 'MOVE_LAYER_DOWN';

// Define the reducer
const layerReducer = (state, action) => {
  if (action.payload == null) return state;
  switch (action.type) {
    case ADD_LAYER:
      return [...state, action.payload];
    case DELETE_LAYER:
      return state.filter(layer => layer.id !== action.payload);
    case CHANGE_LAYER:
      return state.map(asset =>
        asset.id === action.payload.id ? action.payload : asset
      );
    case SET_LAYERS:
      return action.payload;

    case MOVE_LAYER_UP: {
      const index = state.findIndex(layer => layer.id === action.payload);
      if (index < state.length - 1) {
        const newState = [...state];
        [newState[index], newState[index + 1]] = [newState[index + 1], newState[index]];
        return newState;
      }
      return state;
    }
    case MOVE_LAYER_DOWN: {
      const index = state.findIndex(layer => layer.id === action.payload);
      if (index > 0) {
        const newState = [...state];
        [newState[index], newState[index - 1]] = [newState[index - 1], newState[index]];
        return newState;
      }
      return state;
    }
    default:
      return state;
  }
};

// Create the context
export const LayerContext = createContext();

// Create a provider component
export const LayerProvider = ({ children }) => {
  const [layers, dispatch] = useReducer(layerReducer, []);

  return (
    <LayerContext.Provider value={{ layers, dispatch }}>
      {children}
    </LayerContext.Provider>
  );
};
